/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { Fragment } from 'react';
import { Checkbox } from '@airwallex/forms';
import { space } from '@airwallex/global';
import { useField } from 'formik';
import { Input } from '../form';
import { useTranslation } from 'react-i18next';
import { LinkInfoData } from './types';
import { nameCss, nonFirstInputCss } from './styles';
import Address from '@/components/form/address';

type Props = {
  linkInfo?: LinkInfoData;
  submitDisabled?: boolean;
  onSubmit?: () => void;
};

const Index: React.FC<Props> = ({ linkInfo }) => {
  const { t } = useTranslation();
  const [sendEmailField, , sendEmailHelper] = useField<boolean>('sendEmail');

  return (
    <div
      css={css`
        width: calc(100% + 16px);
        margin-left: -8px;
      `}
    >
      {linkInfo?.requiredShopperData?.name && (
        <Input
          name="name"
          css={nameCss}
          label={t('pay_by_link.form.name.label')}
          placeholder={t('pay_by_link.form.name.placeholder')}
          maxLength={100}
        />
      )}
      {linkInfo?.requiredShopperData?.email && (
        <Fragment>
          <Input
            css={nonFirstInputCss}
            name="email"
            label={t('pay_by_link.form.email.label')}
            type="email"
            placeholder={t('pay_by_link.form.email.placeholder')}
            maxLength={200}
          />
          <Checkbox
            name="sendEmail"
            label={t('pay_by_link.form.send_receipt.label')}
            checked={sendEmailField.value}
            value=""
            onChange={() => sendEmailHelper.setValue(!sendEmailField.value)}
            css={css`
              padding: ${space.xxs} ${space.xs} 0 ${space.xs};
            `}
          />
        </Fragment>
      )}
      {linkInfo?.requiredShopperData?.phoneNumber && (
        <Input
          css={nonFirstInputCss}
          name="phoneNumber"
          label={t('pay_by_link.form.phone_number.label')}
          placeholder={t('pay_by_link.form.phone_number.placeholder')}
          maxLength={50}
        />
      )}
      {linkInfo?.requiredShopperData?.reference && (
        <Input
          css={nonFirstInputCss}
          name="reference"
          label={t('pay_by_link.form.reference.label')}
          placeholder={t('pay_by_link.form.reference.placeholder')}
          maxLength={200}
        />
      )}
      {linkInfo?.requiredShopperData?.shippingAddress && (
        <Address label={t('pay_by_link.form.shipping_address.label')} name="shippingAddress" />
      )}
      {linkInfo?.requiredShopperData?.comment && (
        <Input
          css={nonFirstInputCss}
          name="comment"
          label={t('pay_by_link.form.comment.label', { merchant: linkInfo?.merchant || '' })}
          maxLength={250}
          placeholder={t('pay_by_link.form.message.placeholder')}
          optional
          optionalDisplayText={t('pay_by_link.label.optional')}
        />
      )}
    </div>
  );
};

export default Index;
